export const LabTestResultPage = (destinationLang) => {
  return [
    {
      FormKey: 'lab-test-result-navbar-title-lab',
      Key: 'مشاهده جواب',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-test-title-referral-date',
      Key: 'تاریخ مراجعه',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-test-title-referral-time',
      Key: 'ساعت مراجعه',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-tracking-code',
      Key: 'شماره پیگیری',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-test-title-referral-location',
      Key: 'محل مراجعه',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-test-title-date-time',
      Key: 'زمان مراجعه',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-test-title-title',
      Key: 'عنوان',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'lab-test-red-label-unable-to-get-result-because-bedehkari',
      Key: 'بدلیل بدهکاری امکان دریافت جواب وجود ندارد',
      DistinitationLanguage: destinationLang,
    },
  ];
};
